export default class Calculator {

    public static SOLD_OUT = 'SOLD_OUT';

    public static ON_REQUEST = 'ON_REQUEST';

    /**
     * Determines whether its argument represents a JavaScript number
     */
    public static isNumeric(v): boolean {
        return !isNaN(parseFloat(v)) && isFinite(v);
    }

    /**
     * Determines whether its [[SOLD_OUT]]
     */
    public static isSoldOut(v): boolean {
        return v === Calculator.SOLD_OUT;
    }

    /**
     * Determines whether its [[ON_REQUEST]]
     */
    public static isOnRequest(v): boolean {
        return v === Calculator.ON_REQUEST;
    }

    /**
     * Returns min price from array
     */
    public static minPrice(values: any[]): string | null {
        // Exclude [[null]], [[SOLD_OUT]] & [[ON_REQUEST]]
        const prices = values.filter(Calculator.isNumeric);

        return prices.length ? `${ Math.min.apply(null, prices) }` : null;
    }
}



// WEBPACK FOOTER //
// ./src/helpers/calculator.ts